"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Treatment {
    constructor(data) {
        this.meta = data.meta;
        this.times = data.times;
    }
    get currentTime() {
        let currentTime = -1;
        let keepLooking = true;
        this.times.forEach((time) => {
            if (keepLooking) {
                if (time.samplesAssignedForTime < time.samplesTotalThisTime) {
                    currentTime = time.order;
                    keepLooking = false;
                }
            }
        });
        return currentTime;
    }
    get missingSamplesCurrentTime() {
        let missingSamplesCurrentTime = 0;
        if (this.currentTime !== -1) {
            missingSamplesCurrentTime = this.times[this.currentTime].samplesTotalThisTime - this.times[this.currentTime].samplesAssignedForTime;
        }
        return missingSamplesCurrentTime;
    }
    get assignedSamplesCurrentTime() {
        let assignedSamplesCurrentTime = 0;
        if (this.currentTime !== -1) {
            assignedSamplesCurrentTime = this.times[this.currentTime].samplesAssignedForTime;
        }
        return assignedSamplesCurrentTime;
    }
    get totalSamplesCurrentTime() {
        let totalSamplesCurrentTime = 0;
        if (this.currentTime !== -1) {
            totalSamplesCurrentTime = this.times[this.currentTime].samplesTotalThisTime;
        }
        return totalSamplesCurrentTime;
    }
}
exports.default = Treatment;
